import clsx from 'clsx';
import Icon from '../atoms/Icon';
import styles from '../../styles/components/atoms/Rating.module.scss';

interface RatingProps {
  className?: string;
  onClick?: () => void;
  icon?: string;
  label?: any;
  value?: string | number;
  unit?: string;
  dark?: boolean;
  em?: boolean;
  full?: boolean;
  half?: boolean;
  float?: boolean;
  small?: boolean | true;
  medium?: boolean;
  large?: boolean;
}

export default function Rating(props: RatingProps) {
  const {
    icon,
    label,
    value,
    unit,
    em,
    dark,
    onClick,
    full,
    half,
    float,
    small,
    medium,
    large,
    className,
  } = props;
  const { rating } = styles;
  const h = large ? 'large' : medium ? 'medium' : 'small'; //small ? "small" : "";
  const w = full ? 'full' : half ? 'half' : '';
  const bold = em || icon === 'rating';
  const valueStr =
    !value || value === 'NaN'
      ? '0.0'
      : typeof value === 'number'
      ? value.toFixed(1)
      : value;

  const classes = clsx(
    rating,
    { [styles[h]]: h },
    // {[styles[w]]: !!w},
    { [styles.float]: float },
    { [styles.full]: full },
    { [styles.dark]: medium ? false : !!dark }
    // {[styles.linked]: !!onClick},
    // {[styles.labeled]: !!label}
  );

  return (
    <div className={classes} onClick={onClick}>
      <Icon name="rating" />
      <span>
        <small>
          <b>{valueStr}</b>
        </small>
      </span>
      <span>
        {small ? (
          <small>{typeof label === 'string' ? <b>{label}</b> : label}</small>
        ) : (
          { label }
        )}
      </span>
    </div>
  );
}
